import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../logo.png';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="main-header">
            <div className="header-container">
                <div className="logo">
                    <Link to="/">
                        <img src={logo} alt="D-Astars Logo" className="header-logo" />
                    </Link>
                </div>
                <button className="mobile-menu-btn" onClick={toggleMenu}>
                    <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
                </button>
                <nav className={`main-nav ${isMenuOpen ? 'active' : ''}`}>
                    <ul>
                        <li><Link to="/" onClick={toggleMenu}>Home</Link></li>
                        <li><Link to="/about" onClick={toggleMenu}>About Us</Link></li>
                        <li><Link to="/products" onClick={toggleMenu}>Products</Link></li>
                        <li><Link to="/careers" onClick={toggleMenu}>Careers</Link></li>
                        <li><Link to="/contact" onClick={toggleMenu}>Contact Us</Link></li>
                    </ul>
                </nav>
                <div className="contact-info">
                    <a href="https://wa.me/8237434068" className="whatsapp-button">
                        <i className="fab fa-whatsapp"></i> Chat with Us
                    </a>
                </div>
            </div>
        </header>
    );
};

export default Header;
